<template>
  <TvBase storage-key="tv1id">
    <div v-if="state === 'INTERSTICIEL'" class="view tv dark">
      <IntersticeMastHead />
    </div>
    <div v-if="state !== 'INTERSTICIEL' && screenData" class="view tv dark">
      <MastHead v-if="state === ''" :data="screenData" />
      <Screen v-if="state === 'SYNTHESIS'" :data="screen2">
        <template #aside>
          <AsideBlock>
            <h4>{{ $t('sections.synthesis') }}</h4>
            <TransportList :current-filter="screenData.currentTransportFilter" :distribution="optimizedDistribution" :index="index" />
          </AsideBlock>
        </template>
        <TableBlock :data="screen2.data" :index="index" :scrollIndex="scrollIndex" />
      </Screen>
      <Screen v-if="state === 'IMPACT'" :data="screen3">
        <template #header>
          <HeaderBlock>
            <TransportList :current-filter="screenData.currentTransportFilter" />
            <Baseline :data="header.baseline" />
          </HeaderBlock>
        </template>
        <TableBlock :data="screen3.data" :index="index" :scrollIndex="scrollIndex" />
      </Screen>
      <Screen v-if="state === 'TRANSIT' && distribution === 'LOCALISATION'" :data="screen4">
        <template #header>
          <HeaderBlock>
            <TransportList :current-filter="screenData.currentTransportFilter" />
            <Baseline :data="header.baseline" />
          </HeaderBlock>
        </template>
        <TableBlock :data="screen2.data" :index="index" :scrollIndex="scrollIndex" style="margin-top: 78px" />
      </Screen>
      <Screen v-if="state === 'TRANSIT' && (distribution === 'TIME' || distribution === 'PERCENTAGE')" :data="screen5">
        <template #header>
          <HeaderBlock>
            <TransportList :current-filter="screenData.currentTransportFilter" />
            <Baseline :data="header.baseline" />
          </HeaderBlock>
        </template>
        <TableBlock :data="screen2.data" :index="index" :scrollIndex="scrollIndex" style="margin-top: 78px" />
      </Screen>
      <Screen v-if="state === 'OUTLIER'">
        <template #header>
          <HeaderBlock>
            <TransportList :current-filter="screenData.currentTransportFilter" />
            <Baseline :data="header.baseline" />
          </HeaderBlock>
        </template>
        <SensitiveCase />
      </Screen>
      <Screen v-if="state === 'ENVIRONMENTAL'">
        <template #header>
          <HeaderBlock>
            <TransportList :current-filter="screenData.currentTransportFilter" />
            <Baseline :data="header.baseline" />
          </HeaderBlock>
        </template>
        <EnvironmentalImpact :environmentalMode="environmentalMode" />
      </Screen>
    </div>
  </TvBase>
</template>

<script>
import Tv from './TvMixin';
export default {
  name: 'Tv1',
  mixins: [Tv],

  data() {
    return {
      state: 'INTERSTICIEL',
      lastState: '',
      distribution: 'LOCALISATION',
      environmentalMode: 0,
      index: -1,
      screenData: null,
      scrollIndex: 0,
    };
  },

  computed: {
    header() {
      const { averageTime } = this.screenData;
      return {
        baseline: {
          value: averageTime,
          sub: ' min',
          caption: `${this.$t('averageTimeByCurrentSite')} :`,
        },
      };
    },

    optimizedDistribution() {
      if (this.index >= 0) {
        const { filteredCollaborators, sites } = this.screenData;
        return this.computeTransportDistribution(sites[this.index], filteredCollaborators).optimized;
      } else {
        return this.computeActualSiteTransportDistribution(this.screenData.filteredCollaborators).optimized;
      }
    },

    screen2() {
      const { averageTime, sites } = this.screenData;
      return {
        heading: {
          caption: this.$t('averageAccessTime'),
          icon: 'clock',
          baseline: {
            value: averageTime,
            sub: ' min',
            caption: `${this.$t('CurrentSiteName')} :`,
          },
        },
        data: {
          entries: this.computeAverageTime(sites, averageTime),
        },
      };
    },

    screen3() {
      const { filteredCollaboratorsCount, sites } = this.screenData;
      const value = filteredCollaboratorsCount;
      return {
        heading: {
          caption: this.$t('improvements'),
          icon: 'happy',
          baseline: {
            value,
            caption: `${this.$t('collaboratorCount')} :`,
          },
        },
        data: {
          specifications: [
            {
              className: {
                big: true,
              },
            },
            {
              type: 'heading',
              caption: `${this.$t('collaboratorsNumber')} :`,
            },
            {
              type: 'heading',
              caption: `${this.$t('averageTimeSaved')} :`,
            },
          ],
          entries: this.computeImpact(sites, 'improvement'),
        },
      };
    },

    screen4() {
      const value = this.screenData.filteredCollaboratorsCount;

      return {
        heading: {
          caption: this.$t('collaboratorTimeByLocation'),
          icon: 'clock',
          baseline: {
            value,
            caption: `${this.$t('collaboratorCount')} :`,
          },
        },
      };
    },

    screen5() {
      return {
        heading: {
          caption: this.$t(this.distribution === 'PERCENTAGE' ? 'remote.timePercentage' : 'remote.time'),
          icon: 'clock',
        },
      };
    },
  },
};
</script>
